module.exports = __webpack_public_path__ + "static/down.44fbae86.svg";